import { createSlice } from '@reduxjs/toolkit';
import { reHydrateStore } from '../utils/local-storage';

const initialState = {
  timeLeft: null,
};

const slice = createSlice({
  name: 'booking',
  initialState: reHydrateStore('booking') || initialState,
  reducers: {
    setTimeLeft: (state, { payload }) => ({
      ...state,
      timeLeft: payload,
    }),
    restore: () => initialState,
  },
});

export const { setTimeLeft } = slice.actions;

export default slice.reducer;
